// extracted by mini-css-extract-plugin
export var last_news_section = "news_section-module--last_news_section--GPb-x";
export var news_head = "news_section-module--news_head--M02NP";
export var post_description = "news_section-module--post_description--qWW+A";
export var post_info_wrapper = "news_section-module--post_info_wrapper--fZxu5";
export var post_tag_name = "news_section-module--post_tag_name--xw-K+";
export var posts_wrapper = "news_section-module--posts_wrapper--Zo2jR";